<template>
	<div style="background-color:#FFF">
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100 text-center" style="display: flex; justify-content: space-between; align-items: center; flex-direction: row; margin-bottom: 20px">
				<div>
					<h3 class="order-title">តារាងបង់ប្រាក់</h3>
				</div>
				<qr-code :text="'https://golden-town-client.traware.com/#/tracking/' + loan.hash" :size="300" style="width: 100px;"></qr-code>
			</div>

			<div class="md-layout-item md-small-size-50 md-size-50">
				<table style="width: 100%; border-collapse: collapse">
					<tr>
						<td class="print-logn-td">លេខកូដរំលោះ</td>
						<td class="print-logn-td" style="width: 20px">:</td>
						<td class="print-logn-td"><b><span v-if="String(loan.hash).length > 0">{{loan.hash}}</span><span v-else>N/A</span></b></td>
					</tr>
					<tr>
						<td class="print-logn-td">លេខឡូតិ៍</td>
						<td class="print-logn-td">:</td>
						<td class="print-logn-td"><b><span v-if="String(loan.lot).length > 0">{{loan.lot}} ({{loan.project_name}})</span><span v-else>N/A</span></b></td>
					</tr>
					<tr>
						<td class="print-logn-td">តម្លៃសរុប</td>
						<td class="print-logn-td">:</td>
						<td class="print-logn-td"><b><span v-if="String(loan.amount).length > 0">{{config.moneylify(loan.amount)}}</span><span v-else>N/A</span></b></td>
					</tr>
					<tr>
						<td class="print-logn-td">ប្រាក់បង់មុន</td>
						<td class="print-logn-td">:</td>
						<td class="print-logn-td"><b><span v-if="paymentList.length > 0">{{config.moneylify(paymentList[0].principal+paymentList[0].interest)}}</span><span v-else>N/A</span></b></td>
					</tr>
					<tr>
						<td class="print-logn-td">រយៈពេលបង់រំលោះ</td>
						<td class="print-logn-td">:</td>
						<td class="print-logn-td"><b><span v-if="String(loan.total_term).length > 0">{{loan.total_term - 1}} ខែ</span><span v-else>N/A</span></b></td>
					</tr>
				</table>
			</div>

			<div class="md-layout-item md-small-size-50 md-size-50">
				<table style="width: 100%; border-collapse: collapse">
					<tr>
						<td class="print-logn-td">លេខកូដអតិថិជន</td>
						<td class="print-logn-td" style="width: 20px">:</td>
						<td class="print-logn-td"><b><span v-if="String(loan.client_hash).length > 0">{{loan.client_hash}}</span><span v-else>N/A</span></b></td>
					</tr>
					<tr>
						<td class="print-logn-td">ឈ្មោះអតិថិជន</td>
						<td class="print-logn-td">:</td>
						<td class="print-logn-td"><b><span v-if="String(loan.client_name).length > 0">{{loan.client_name}}</span><span v-else>N/A</span></b></td>
					</tr>
					<tr>
						<td class="print-logn-td">លេខទូរស័ព្ទ</td>
						<td class="print-logn-td">:</td>
						<td class="print-logn-td"><b><span v-if="String(loan.client_phone).length > 0">{{loan.client_phone}}</span><span v-else>N/A</span></b></td>
					</tr>
					<tr>
						<td class="print-logn-td">ថ្ងៃខែឆ្នាំចាប់ផ្តើមរំលោះ</td>
						<td class="print-logn-td">:</td>
						<td class="print-logn-td"><b><span v-if="paymentList.length > 0">{{config.datelifyShort(paymentList[0].due_date)}}</span><span v-else>N/A</span></b></td>
					</tr>
					<tr>
						<td class="print-logn-td">ថ្ងៃខែឆ្នាំបញ្ចប់រំលោះ</td>
						<td class="print-logn-td">:</td>
						<td class="print-logn-td"><b><span v-if="paymentList.length > 0">{{config.datelifyShort(paymentList[paymentList.length - 1].due_date)}}</span><span v-else>N/A</span></b></td>
					</tr>
				</table>
			</div>

			<div class="md-layout-item md-small-size-100 md-size-100">
				<table v-if="paymentList.length > 0"
					style="border-collapse: collapse; width: 100%;border:1px solid black; font-weight: 9px !important;margin-top: 10px">
					<thead>
						<tr style="border: 1px solid black;padding: 5px">
							<td class="print-row print-row-bold">ល.រ</td>
							<td class="print-row print-row-bold">លេខកូដ</td>
							<td class="print-row print-row-bold">កាលបរិច្ឆេទ<br>បង់ប្រាក់</td>
							<td class="print-row print-row-bold">ប្រាក់ដើម<br>ត្រូវបង់</td>
							<td class="print-row print-row-bold">ការប្រាក់<br>ត្រូវបង់</td>
							<td class="print-row print-row-bold">ទឹកប្រាក់<br>ត្រូវបង់សរុប</td>
							<td class="print-row print-row-bold">ប្រាក់ដើម<br>នៅសល់</td>
							<td class="print-row print-row-bold">ផ្សេងៗ</td>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(payment, index) in paymentList" style="border: 1px solid black">
							<td class="print-row"><b>{{ payment.term_id }}</b></td>
							<td class="print-row">{{ payment.hash }}</td>
							<td class="print-row">{{config.datelifyShort(payment.due_date) }}</td>
							<td class="print-row">{{config.moneylify(payment.principal) }}</td>
							<td class="print-row">{{config.moneylify(payment.interest) }}</td>
							<td class="print-row"><b>{{config.moneylify(payment.interest + payment.principal)}}</b></td>
							<td class="print-row" style="border: 1px solid black;padding: 5px;text-align: center;">{{config.moneylify(payment.balance) }}</td>
							<td class="print-row"></td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<table style="width: 100%; margin-top: 10px">
						<thead>
							<tr class="no-hover">
								<td style="text-align: center; font-weight: bold;">ប្រធានក្រុមហ៊ុន</td>
								<td style="text-align: center; font-weight: bold;display:flex; justify-content: center;align-items: center;">អតិថិជន</td>
							</tr>
							<tr class="no-hover">
								<td style="text-align: center;height: 100px; font-weight: bold;"></td>
								<td style="text-align: center;height: 100px; font-weight: bold;"></td>
							</tr>
							<tr class="no-hover">
								<td style="text-align: center; font-weight: bold;">ឃុន ស្រី</td>
								<td style="text-align: center; font-weight: bold; display:flex; justify-content: center;align-items: center;">{{ loan.client_name }}</td>
							</tr>
						</thead>
					</table>
				<!-- <table style="width:100%">
					<tr>
						<td class="center">ស្នាមមេដៃម្ចាស់កម្ចី</td>
						<td class="center">ស្នាមមេដៃកូនកម្ចី</td>
						<td class="center" v-for="guarantor in guarantorList">ស្នាមមេដៃអ្នកធានា</td>
					</tr>
					<tr style="height: 120px">
						<td></td>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td class="center">សុខ វុទ្ធី</td>
						<td class="center">{{ loan.name_khmer }}</td>
						<td class="center" v-for="guarantor in guarantorList">{{ guarantor.name_khmer }}</td>
					</tr>
				</table> -->
			</div>
		</div>
	</div>
</template>

<script>
	import VueQRCodeComponent from 'vue-qr-generator'
	export default {
		components: {
			'qr-code': VueQRCodeComponent
		},
		created() {
			this.getLoan();
		},
		mounted() { },
		data() {
			return {
				loaded: false,
				paymentList: [],
				loan: {
					id: "",
					hash_id: "",
					interest_amount: "",
					loan_fee: "",
					total_payment: "",
					amount: "",
					term: "",
					initial_payment: "",
					monthly_payment: "",
					start_date: "",
					end_date: "",
					client_name: "",
					phone: "",
					next_payment: "",
					loan_balance: "",
					total_paid: "",
					note: "",
					status: ""
				},
			}
		},
		methods: {
			getLoan(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/loan/get/" + this.$route.params.hash).then(data => {
					this.loan = data.body.data
					this.$http.get(this.config.api + "/admin/loan/get_payment/" + this.$route.params.hash).then(data => {
						this.paymentList = data.body.data
						this.loaded = true
						setTimeout(() => {
							window.print();
						}, 2000)
					})

				})
			},
		}
	}
</script>

<style>
	table {
		page-break-inside:auto;
	}
   tr {
		page-break-inside:avoid;
		page-break-after:auto
	}
   thead {
		display:table-header-group
	}
   tfoot {
		display:table-footer-group
	}

	.no-hover:hover {
		background-color: #FFF !important;
	}
	.center {
		text-align: center;
	}

	body {
		background-color: #FFF !important;
	}
	.print-row-bold {
		font-weight: bold;
	}

	.print-row {
		border: 1px solid black;
		text-align: center;
		padding: 5px;
		font-size: 12px;
	}

	.print-logo {
		height: 100px !important;
		margin: 16px;
	}

	.order-title {
		margin-top: 0;
		margin-bottom: 0;
		font-family: 'Moul';
	}

	.product-thumbnail {
		width: 64px;
		height: 64px;
		margin-right: 13px;
	}
	.print-logn-td {
		font-size: 13px;
		border-top: 1px solid #eee;
		border-bottom: 1px solid #eee;
		padding: 5px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/PrintLoan.vue